import logger from '../utils/logger';
// smartreader-frontend/src/services/push.js
// Requires REACT_APP_VAPID_PUBLIC_KEY to be configured with the Base64-encoded
// Web Push VAPID public key. This must match the backend's VAPID_PUBLIC_KEY so
// subscriptions created here can be validated when the API sends notifications.
import api from './api';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

export const subscribeToPush = async () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!('Notification' in window)) {
    logger.log('Push notifications are not supported in this browser.');
    return null;
  }

  if (!('serviceWorker' in navigator)) {
    logger.log('Service workers are not supported in this browser.');
    return null;
  }

  if (!VAPID_PUBLIC_KEY) {
    logger.warn(
      'Cannot subscribe to push notifications because REACT_APP_VAPID_PUBLIC_KEY is not configured.',
    );
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      if (permission === 'denied') {
        logger.debug('Push notification permission was denied by the user.');
      }
      return null;
    }

    const registration = await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
    }

    const subscriptionPayload =
      typeof subscription.toJSON === 'function' ? subscription.toJSON() : subscription;

    await api.post('/notifications/subscribe', subscriptionPayload);

    return subscription;
  } catch (error) {
    logger.error('Failed to subscribe to push notifications:', error);
    return null;
  }
};

export default subscribeToPush;
